export default __webpack_public_path__ + "assets/images/d4d4e0e540e97db04aacf49ed3bb142d.png";